import { AppMarketPage } from '../enums';
import type { IRoute } from '../models/junk-yard';
import { Path } from '../models/junk-yard';

export const convertStringToBi = (value: string) => {
  return value.replace(/-/g, '_');
};

export const getPathForBi = (path?: string) => {
  return path === Path.HOME || ''
    ? AppMarketPage.HOMEPAGE
    : path === Path.WEB_SOLUTION
    ? AppMarketPage.APP_PAGE
    : path ?? '';
};

export const getReferralInfo = (
  referral: string | undefined,
  route: IRoute | undefined,
  referrerNameForBI: string | undefined,
): string => {
  let result = '';
  if (referral) {
    result = referral;
  } else if (route && route.path) {
    result = getPathForBi(route.path);
  } else if (referrerNameForBI) {
    result = referrerNameForBI;
  } else if (route) {
    result = AppMarketPage.HOMEPAGE;
  }
  return result;
};

export const getRouteBiData = (
  route: IRoute | undefined,
  prevRoute: IRoute | undefined,
  referrerNameForBI: string | undefined,
): { referralInfo: string; subCategory: string; searchTerm: string } => {
  const subCategory =
    (route?.subCategories && route.subCategories.join(',')) || '';
  const referralInfo = getReferralInfo(
    route?.referral,
    prevRoute,
    referrerNameForBI,
  );
  const searchTerm = route?.query ? route?.query : prevRoute?.query || '';

  return { referralInfo, subCategory, searchTerm };
};
